import {
    NinchatActionType,
    NinchatDescribeTagsAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

type LimitedNinchatDescribeTagsActionParams = Omit<NinchatActionParams<NinchatDescribeTagsAction>, 'tag_id'>

export const describeTags = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeTagsAction}`,
    async (arg: LimitedNinchatDescribeTagsActionParams, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeTagsAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
